import moment from "moment";
import swal from 'sweetalert2';

const jexcel = require('jexcel');

$(document).ready(function () {
    //Range Picker for step two
    if (document.getElementById('look-back-date-start')) {
        new Lightpick({
            field: document.getElementById('look-back-date-start'),
            secondField: document.getElementById('look-back-date-end'),
            singleDate: false,
            format: 'MM/DD/YYYY',
            onSelect: function (start, end) {
                look_back_date.start = start ? start.format('DD-MM-YYYY') : null;
                look_back_date.end = end ? end.format('DD-MM-YYYY') : null;
            }
        });
    }
    const baseUrl = $("#app_url").val();

    let rowSelected = {};
    let client = null;
    let market = null;
    let sheet = {};
    let sheet_id = {};
    let duplicateRow = [];
    let arrayMarketClient = [];
    let marketClientObj = {};
    let budget = 0;
    let modalTotalBudget = 0;
    let spend = 0;
    let difference = 0;
    let expected_leads_count = 0;
    let look_back_date = {
        start: null,
        end: null
    };

    let slotSelection = {
        header: [],
        rows: [],
        core: [],
        sorts: {},
        filters: [],
        days_list: [],
        filtered: {
            stations_networks: [],
            zones: [],
            programs: [],
            days: [],
            beginning_time: {
                from: '12:00 AM',
                to: '11:59 PM'
            },
            ending_time: {
                from: '12:00 AM',
                to: '11:59 PM'
            }
        }
    };
    let slotConfirmation = {
        header: [],
        rows: [],
        sorts: {}
    };
    let vendorMatching = {
        header: ['Station', 'Vendor'],
        orders: [],
        vendors: [],
        fields: {
            week_of: []
        }
    };

    const getSelectedRowHtml = row => `<span class="border border-dark p-2 selected-row-container"><span class="font-weight-bold"><h5>${row[2]}</h5></span><span>$${row[15]}</span><span>${withDecimals(row[16], 2)}</span></span>`;

    const makeGroup = () => {
        getSpend();
        $('#step-3-selected-rows').html((Object.keys(rowSelected).map(index => getSelectedRowHtml(rowSelected[index]))).join(''));
    }

    /**
     * duplicateRow has original data
     * slotSelection can be reduced if we use filter
     * if filter is used and did change with row will update in dupicateRow
     * So that we can calculate main section
     */
    const updateDuplicateTableRecord = () => {
        slotSelection.rows.forEach(element => {
            const i = duplicateRow.findIndex(e => element[17] === e[17]);
            if (i !== -1) {
                duplicateRow[i] = element;
            }
        });
    }

    //Start events for Slot Selection
    $('#buying-filters-3').on('select2:select', function (e) {
        let filterBy = e.target.name;
        let value = e.params.data.id;
        slotSelection.filtered[filterBy].push(value);
        filterSlotSelectionTable();
    });

    $('#buying-filters-3').on('select2:unselect', function (e) {
        let filterBy = e.target.name;
        let value = e.params.data.id;
        slotSelection.filtered[filterBy] = slotSelection.filtered[filterBy].filter(x => x !== value);
        filterSlotSelectionTable();
    });

    $('#buying-filters-3 .fl-time-picker input').on('changeTime', function () {
        let parent = $(this).parents('label').data('name');
        let name = $(this).attr('name');
        slotSelection.filtered[parent][name] = $(this).val();
        filterSlotSelectionTable();
    });

    $('body').on('click', '#step-3-table .jexcel > thead.resizable > tr > td', function () {
        let column = parseInt($(this).data('x'));
        if (!isNaN(column)) {
            if (slotSelection.sorts.hasOwnProperty(column)) {
                if (slotSelection.sorts[column] === 'desc') {
                    delete slotSelection.sorts[column];
                } else {
                    slotSelection.sorts[column] = slotSelection.sorts[column] === 'asc' ? 'desc' : 'asc';
                }
            } else {
                slotSelection.sorts[column] = 'asc';
            }

            displaySlotSelectionTable();
        }
    });
    //End events for Slot Selection

    //Start events for Slot Confirmation
    $('body').on('click', '#step-4-table .jexcel > thead.resizable > tr > td', function () {
        let column = parseInt($(this).data('x'));
        if (!isNaN(column) && column > 0) {
            if (slotConfirmation.sorts.hasOwnProperty(column)) {
                if (slotConfirmation.sorts[column] === 'desc') {
                    delete slotConfirmation.sorts[column];
                } else {
                    slotConfirmation.sorts[column] = slotConfirmation.sorts[column] === 'asc' ? 'desc' : 'asc';
                }
            } else {
                slotConfirmation.sorts[column] = 'asc';
            }
        }
    });
    //End events for Slot Confirmation

    //Start events for vendor matching
    $('body').on('change', '#step-5-table .vendor-matching select', function () {
        let station = $(this).parents('tr').data('station');
        vendorMatching.orders[station].vendor_id = $(this).val() === 'none' ? null : +$(this).val();
        vendorMatching.orders[station].vendor_markets_id = +$(this).find(':selected').data('vendorMarketsId');
    });
    //End events for vendor matching

    let filterSlotSelectionTable = () => {
        let filtered = slotSelection.filtered;
        let filteredRows = [];

        for (let i = 0; i < slotSelection.core.length; i++) {
            let row = slotSelection.core[i];
            let missed = false;

            if (filtered.stations_networks.length > 0) {
                if (filtered.stations_networks.indexOf(row[2]) === -1) {
                    missed = true;
                }
            }

            if (filtered.zones.length > 0) {
                if (filtered.zones.indexOf(row[3]) === -1) {
                    missed = true;
                }
            }

            if (filtered.programs.length > 0) {
                if (filtered.programs.indexOf(row[4]) === -1) {
                    missed = true;
                }
            }

            if (filtered.days.length > 0) {
                if (filtered.days.indexOf(row[5]) === -1) {
                    missed = true;
                }
            }

            if (
                moment(filtered.beginning_time.from, 'LT').diff(moment(row[6], 'LT')) > 0
                ||
                moment(filtered.beginning_time.to, 'LT').diff(moment(row[6], 'LT')) < 0
            ) {
                missed = true;
            }

            if (
                moment(filtered.ending_time.from, 'LT').diff(moment(row[7], 'LT')) > 0
                ||
                moment(filtered.ending_time.to, 'LT').diff(moment(row[7], 'LT')) < 0
            ) {
                missed = true;
            }

            if (!missed) {
                filteredRows.push(row);
            }
        }
        slotSelection.rows = filteredRows;
        displaySlotSelectionTable();
    };

    let setSlotSelectionFilters = () => {
        let station_network_select = $("#buying-filters-3 .fl-station-network select");
        let zone_select = $("#buying-filters-3 .fl-zone select");
        let program_select = $("#buying-filters-3 .fl-program select");
        let day_select = $("#buying-filters-3 .fl-day select");
        let beginning_time = $("#buying-filters-3 .fl-beginning-time");
        let ending_time = $("#buying-filters-3 .fl-ending-time");

        station_network_select.html('');
        for (let element of slotSelection.filters['stations_networks']) {
            station_network_select.append($('<option value="' + element + '">' + element + '</option>'))
        }

        zone_select.html('');
        for (let element of slotSelection.filters['zones']) {
            zone_select.append($('<option value="' + element + '">' + element + '</option>'))
        }

        program_select.html('');
        for (let element of slotSelection.filters['programs']) {
            program_select.append($('<option value="' + element + '">' + element + '</option>'))
        }

        day_select.html('');
        for (let element of slotSelection.filters['days']) {
            day_select.append($('<option value="' + element + '">' + element + '</option>'))
        }

        station_network_select.select2();
        zone_select.select2();
        program_select.select2();
        day_select.select2();

        beginning_time.find('.from-time').timepicker({ 'timeFormat': 'h:i A', step: 1 });
        beginning_time.find('.to-time').timepicker({ 'timeFormat': 'h:i A', step: 1 });
        ending_time.find('.from-time').timepicker({ 'timeFormat': 'h:i A', step: 1 });
        ending_time.find('.to-time').timepicker({ 'timeFormat': 'h:i A', step: 1 });

        beginning_time.find('.from-time').timepicker('setTime', slotSelection.filtered.beginning_time.from);
        beginning_time.find('.to-time').timepicker('setTime', slotSelection.filtered.beginning_time.to);
        ending_time.find('.from-time').timepicker('setTime', slotSelection.filtered.ending_time.from);
        ending_time.find('.to-time').timepicker('setTime', slotSelection.filtered.ending_time.to);
    };

    let displaySlotSelectionTable = () => {
        multiSort(slotSelection.rows, JSON.parse(JSON.stringify(slotSelection.sorts)));
        jexcel.destroy(document.getElementById('step-3-table'), false);
        let columns = [];
        for (let item of slotSelection.header) {
            const data = {
                type: item === '✔' ? 'checkbox' :
                    (item.toLowerCase() === 'day' ? 'dropdown' : 'text'),
                title: item,
                readOnly: item !== '✔' &&
                    item.toLowerCase() !== 'ad <br> buying' &&
                    item.toLowerCase() !== 'day' &&
                    item.toLowerCase() !== 'beginning <br> time' &&
                    item.toLowerCase() !== 'ending <br> time' &&
                    item.toLowerCase() !== 'rate'
            };
            if (item.toLowerCase() === 'day') {
                data.source = slotSelection.days_list;
            }
            columns.push(data);
        }
        updateDuplicateTableRecord();
        makeGroup();
        $('#step-3-table').jexcel({
            lazyLoading: false,
            loadingSpin: true,
            columnSorting: true,
            tableOverflow: true,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowInsertRow: false,
            allowDeleteRow: false,
            csvHeader: true,
            tableWidth: "70vw",
            tableHeight: "70vh",
            columns: columns,
            data: slotSelection.rows,
            onchange: actions,
        });

        setHeaderArrowsColor('#step-3-table', slotSelection.sorts);

        setSlotSelectionCheckedRowsColor();
    };

    const reCalculateExpextedLeads = () => {
        $('.new-market-sections').each(function () {
            const e = $(this);
            let expected_leads = 0;
            for (let index = 0; index < slotConfirmation.rows.length; index++) {
                const hiddenid = e.find('span[data-hiddenid="' + slotConfirmation.rows[index][18] + '"]').data('hiddenid');
                if (slotConfirmation.rows[index][18] === hiddenid) {
                    expected_leads = expected_leads + Number(slotConfirmation.rows[index][16]);
                }
            }
            e.find('span.selected-expected-leads-count').html(withDecimals(expected_leads, 2))
        })
    }

    let displaySlotConfirmationTable = (arrayMarketClient = null) => {
        jexcel.destroy(document.getElementById('step-4-table'), false);
        const columns = [];
        for (let item of slotConfirmation.header) {
            const data = {
                type: item.toLowerCase() === "market/client" || item.toLowerCase() === "split?" ? 'dropdown' : 'text',
                title: item,
                readOnly: item.toLowerCase() !== "market/client" && item.toLowerCase() !== "split?"
            };
            if (item.toLowerCase() === "market/client") {
                data.source = arrayMarketClient && arrayMarketClient.length > 0 ? arrayMarketClient : [];
            }
            if (item.toLowerCase() === "split?") {
                data.source = ['Split'];
            }
            columns.push(data);
        }
        $('#step-4-table').jexcel({
            lazyLoading: true,
            loadingSpin: true,
            columnSorting: false,
            tableOverflow: true,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowInsertRow: false,
            allowDeleteRow: false,
            allowRenameColumn: false,
            csvHeader: true,
            tableWidth: "70vw",
            tableHeight: "70vh",
            columns: columns,
            data: slotConfirmation.rows,
            onchange: updateSelectedMarketClientTopSection
        });
    };

    const updateSelectedMarketClientTopSection = (instance, cell, x, y, value) => {
        let newMarketSection, differenceSection;
        if (value && value.toLowerCase() === "split" && slotConfirmation.rows[y][15] > 1) {
            const copy = slotConfirmation.rows[y].slice();
            copy[17] = Math.round(Math.random() * 100);
            const splitAdsBuying = Math.ceil(copy[15] / 2);
            const splitExpectedLeads = Math.ceil(copy[16] / 2);
            slotConfirmation.rows[y][15] = slotConfirmation.rows[y][15] - splitAdsBuying;
            slotConfirmation.rows[y][16] = withDecimals(slotConfirmation.rows[y][16] - splitExpectedLeads, 2);
            copy[15] = splitAdsBuying;
            copy[16] = splitExpectedLeads;
            slotConfirmation.rows.push(copy);
        }
        else if (value) {
            newMarketSection = $('#' + value);
            const budgetSection = withoutDollar(newMarketSection.find('.selected-budget').html());
            spend = withoutDollar(newMarketSection.find('.selected-spend').html()) +
                (withoutDollar(slotConfirmation.rows[y][14]) * withoutDollar(slotConfirmation.rows[y][15]));
            differenceSection = spend > 0 ? (budgetSection - spend) : budgetSection;
            if (differenceSection < 0) {
                newMarketSection.addClass('alert-danger');
            } else {
                newMarketSection.removeClass('alert-danger');
            }
        }
        /**remove spend and difference if value is greater than 0 */
        if (slotConfirmation.rows[y][18]) {
            $('.new-market-sections').each(function () {
                const e = $(this);
                const hiddenid = e.find('span[data-hiddenid="' + slotConfirmation.rows[y][18] + '"]').data('hiddenid');
                if (String(slotConfirmation.rows[y][18]) === String(hiddenid)) {
                    const s = withoutDollar(e.find('.selected-spend').html());
                    const q = withoutDollar(slotConfirmation.rows[y][14]) * withoutDollar(slotConfirmation.rows[y][15]);
                    s > 0 && e.find('.selected-spend').html(withDollar(s - q));
                    const d = withoutDollar(e.find('.selected-difference').html());
                    s > 0 && e.find('.selected-difference').html(withDollar(d + q));
                    if (s > 0 && (d + q) < 0) {
                        e.addClass('alert-danger');
                    } else {
                        e.removeClass('alert-danger');
                    }
                    return;
                }
            })
        }
        slotConfirmation.rows[y][18] = +x === 18 ? value : "";
        marketClientObj[value] = "";
        //re-calculate expected leads loop on table and match data with green main sections and place accordingly
        reCalculateExpextedLeads();
        if (value && value.toLowerCase() !== "split") {
            newMarketSection.find('.selected-spend').html(withDollar(spend));
            newMarketSection.find('.selected-difference').html(withDollar(differenceSection));
        } else if (value && value.toLowerCase() === "split") {
            displaySlotConfirmationTable(arrayMarketClient)
        }
    }

    const reRenderTableOnConfirmationSlot = ({ title, hiddenID, addOrRemove }) => {
        if (addOrRemove) {
            arrayMarketClient = arrayMarketClient.filter(function (obj) {
                return obj.id !== hiddenID;
            });
        } else {
            arrayMarketClient.push({ name: title, id: hiddenID });
        }
        displaySlotConfirmationTable(arrayMarketClient);
    }

    let setHeaderArrowsColor = (table, sorts) => {
        $(table + ' .jexcel > thead.resizable > tr > td').removeClass('has_sorting_asc');
        $(table + ' .jexcel > thead.resizable > tr > td').removeClass('has_sorting_desc');

        for (let column in sorts) {
            if (sorts.hasOwnProperty(column)) {
                let nth = +column + 2;
                let c = 1;
                $(table + ' .jexcel > thead.resizable > tr > td').each(function () {
                    if (c === nth) {
                        $(this).addClass('has_sorting_' + sorts[column]);
                    }
                    c++;
                });
            }
        }
    };

    let checkedRowOnChange = (y, value) => {
        if ($($(this).find('td:nth-child(2) input')[y]).is(':checked')) {
            $($(this).find('td:nth-child(2) input')[y]).prop('checked', value);
        } else {
            $($(this).find('td:nth-child(2) input')[y]).prop('checked', value);
        }
    };

    let setSlotSelectionCheckedRowsColor = () => {
        $('#step-3-table table tbody tr').each(function () {
            if ($(this).find('td:nth-child(2) input').is(':checked')) {
                $(this).addClass('bg-blue');
            } else {
                $(this).removeClass('bg-blue');
            }
        });
    };

    const reCalculate = ({ value, y }) => {
        let total_leads = slotSelection.rows[y][10];
        let leads_spot = slotSelection.rows[y][11];
        let rate = withoutDollar(slotSelection.rows[y][14]);
        let old_ad_buying = withoutDollar(slotSelection.rows[y][15]);
        let new_ad_buying = withoutDollar(value);
        let old_total_spend = old_ad_buying * rate;
        let new_total_spend = new_ad_buying * rate;

        // let new_cost_lead = new_total_spend > 0 && total_leads > 0 ? new_total_spend / total_leads : 0;//uz

        let old_expected_leads = leads_spot * old_ad_buying;
        let new_expected_leads = leads_spot * new_ad_buying;

        //Update in slot selection rows
        slotSelection.rows[y][9] = withDollar(withoutDollar(slotSelection.rows[y][9]) + new_total_spend - old_total_spend);
        let new_cost_lead = withoutDollar(slotSelection.rows[y][9]) > 0 && total_leads > 0 ? withoutDollar(slotSelection.rows[y][9]) / total_leads : 0;
        // slotSelection.rows[y][9] = withDollar(new_total_spend);//uz
        slotSelection.rows[y][12] = withDollar(new_cost_lead);
        slotSelection.rows[y][15] = new_ad_buying;
        slotSelection.rows[y][16] = withDecimals(new_expected_leads, 4);

        //Update in table
        let total_spend_td = $('#step-3-table table tbody tr[data-y="' + y + '"] td[data-x="' + 9 + '"]');
        let cost_lead_td = $('#step-3-table table tbody tr[data-y="' + y + '"] td[data-x="' + 12 + '"]');
        let ad_buying_td = $('#step-3-table table tbody tr[data-y="' + y + '"] td[data-x="' + 15 + '"]');
        let expected_leads_td = $('#step-3-table table tbody tr[data-y="' + y + '"] td[data-x="' + 16 + '"]');
        total_spend_td.html(slotSelection.rows[y][9]);
        // total_spend_td.html(withDollar(new_total_spend));//uz
        cost_lead_td.html(withDollar(new_cost_lead));
        ad_buying_td.html(new_ad_buying);
        expected_leads_td.html(withDecimals(new_expected_leads, 4));

        //Update top messages
        spend += new_total_spend - old_total_spend;
        difference = spend > 0 ? (budget - spend) : budget;
        expected_leads_count += new_expected_leads - old_expected_leads;

        //Set header red if has debt
        if (difference < 0) {
            $("#step-3-messages").addClass('alert-danger');
        } else {
            $("#step-3-messages").removeClass('alert-danger');
        }
        $('.selected-budget').html(withDollar(budget));
        $('.selected-spend').html(withDollar(spend));
        $('.selected-difference').html(withDollar(difference));
        $('.selected-expected-leads-count').html(withDecimals(expected_leads_count, 4));
    }

    const calculateExpectedLeads = () => {
        $('.selected-expected-leads-count').html(
            withDecimals(Object.keys(rowSelected).reduce((prev, key) => {
                prev += rowSelected[key][16];
                return prev;
            }, 0), 2)
        );
    }

    const getSpend = (y = null) => {
        rowSelected = {};
        const sumArray = duplicateRow.map(row => {
            if (row[0]) {
                const value = withoutDollar(row[14]) * withoutDollar(row[15]);
                const expected_leads = withoutDollar(row[11]) * withoutDollar(row[15]);
                const i = slotSelection.rows.findIndex(e => row[17] === e[17]);
                if (y && i !== -1 && slotSelection.rows[i][17] === row[17]) {
                    // slotSelection.rows[i][16] = expected_leads.toFixed(2);
                    slotSelection.rows[i][16] = withoutDollar(slotSelection.rows[i][11]) * withoutDollar(slotSelection.rows[i][15]);
                    const expected_leads_td = $('#step-3-table table tbody tr[data-y="' + i + '"] td[data-x="' + 16 + '"]');
                    expected_leads_td.html(slotSelection.rows[i][16]);
                }
                rowSelected[row[2]] = {
                    ...JSON.parse(JSON.stringify(row)),
                    15: rowSelected[row[2]] ? rowSelected[row[2]][15] + value : value,
                    16: rowSelected[row[2]] ? rowSelected[row[2]][16] + expected_leads : expected_leads
                }

                return value;
            }

            return 0;
        });
        calculateExpectedLeads();

        return sumArray.reduce((partialSum, a) => partialSum + a, 0);
    }

    const reCalculateRate = (y) => {
        //Update top messages
        spend = getSpend(y);
        difference = spend > 0 ? (budget - spend) : budget;
        // expected_leads_count = $('.selected-expected-leads-count').html() - slotSelection.rows[y][16];

        //Set header red if has debt
        if (difference < 0) {
            $("#step-3-messages").addClass('alert-danger');
        } else {
            $("#step-3-messages").removeClass('alert-danger');
        }
        $('.selected-budget').html(withDollar(budget));
        $('.selected-spend').html(withDollar(spend));
        $('.selected-difference').html(withDollar(difference));
    }

    const fetchCalculationOnChange = async (row, y) => {
        return new Promise((resolve, reject) => {
            const button = $("#refresh-data");
            button.attr('disabled', true);
            button.find('.fa').hide();
            button.find('.fa-spinner').show();
            // const data = [row[1], "", row[2], row[3], row[4], row[5], row[6], row[7], row[14]];
            let form = $('#step-1-form');
            let action = form.attr('action');
            var market_id = $("#buying-market-client").find('option:selected').attr("data-market_id");
            var client_id = $("#buying-market-client").find('option:selected').attr("data-client_id");

            $.ajax({
                type: 'POST',
                url: action,
                enctype: 'multipart/form-data',
                data: {
                    client_id: client_id,
                    market_id: market_id,
                    budget: form.find('#buying-budget').val(),
                    look_back_date: look_back_date,
                    header: JSON.stringify(sheet.header),
                    // rows: JSON.stringify([data]),
                    spreadsheet_id: form.find('#buying-spreadsheet').val(),
                    sheet_id: form.find('#buying-sheet').val(),
                },
                success: function (data) {
                    if (data.success && data.rows && data.rows.length > 0) {
                        slotSelection.rows[y] = data.rows.find(element => element[17] === row[17]);
                    } else {
                        $('#step-3-errors').html(data["errors"].join('<br>')).fadeIn();
                    }

                    button.attr('disabled', false);
                    button.find('.fa').show();
                    button.find('.fa-spinner').hide();
                    resolve();
                },
                error: function () {
                    button.attr('disabled', false);
                    button.find('.fa').show();
                    button.find('.fa-spinner').hide();
                    reject();
                }
            });
        });
    }

    let updateRateData = (column, row, value, checked = false) => {
        return new Promise((resolve, reject) => {
            var key = '';
            if (column == 5) { //days
                key = 'day';
            } else if (column == 6) { //begenning time
                key = 'time_begin';
            } else if (column == 7) { //ending time
                key = 'time_end';
            } else if (column == 14) { //rate
                key = 'rate';
            } else if (column == 15 || column == 0) { //addBuying
                key = 'ads_buying';
            }
            $.ajax({
                type: 'POST',
                url: baseUrl + 'update-rate-table-value',
                enctype: 'multipart/form-data',
                data: {
                    row,
                    key,
                    value,
                    checked
                },
                success: function (data) {
                    resolve(true);
                },
                error: function (err) {
                    console.log(err);
                    $(".btn-resume").hide();
                    $(".btn-supplemental").hide();
                    reject(false);
                }
            });
        });
    }

    let actions = async function (instance, cell, x, y, value) {
        console.log(slotSelection.rows[y][17], x, y, value);
        if (+x === 14) {
            await updateRateData(x, slotSelection.rows[y][17], withoutDollar(value), true);
            await fetchCalculationOnChange(slotSelection.rows[y], y);
            reCalculateRate(y);
            displaySlotSelectionTable();
        } else if (+x === 15) {
            value = parseInt(value);
            slotSelection.rows[y][+x] = value;
            checkedRowOnChange(y, value > 0 ? true : false);
            slotSelection.rows[y][0] = value > 0 ? true : false;
            await updateRateData(x, slotSelection.rows[y][17], value, value > 0 ? true : false);
            reCalculateRate(y);
            setSlotSelectionCheckedRowsColor();
        } else if (+x === 0) {
            slotSelection.rows[y][+x] = value;
            setSlotSelectionCheckedRowsColor();
            await updateRateData(x, slotSelection.rows[y][17], value ? slotSelection.rows[y][15] : 0, value);
            reCalculateRate(y);
        } else {
            await updateRateData(x, slotSelection.rows[y][17], value, true);
            slotSelection.rows[y][+x] = value;
            await fetchCalculationOnChange(slotSelection.rows[y], y);
            displaySlotSelectionTable();
        }
        makeGroup();
        //Update in core also
        let coreIndex = slotSelection.core.findIndex(n => n[17] === slotSelection.rows[y][17]);
        slotSelection.core[coreIndex] = slotSelection.rows[y];
    };

    let getSpreedSheet = (sheet_id) => {
        if (sheet_id) {
            $.ajax({
                type: 'GET',
                url: baseUrl + 'buying-get-sheets/' + sheet_id + '/',
                processData: false,
                contentType: 'application/json',
                success: function (data) {
                    if (data.success) {
                        let dropdown = $("#buying-sheet");
                        dropdown.html('');
                        $.each(data["sheets"], function (key, sheet) {
                            dropdown.append($("<option />").val(sheet).text(sheet));
                        });
                    } else {
                        $('#google_login_button').show();
                        $('#start-new').hide();
                    }
                }
            });
        }
    };

    let multiSort = (array, sortObject = {}) => {
        const sortKeys = Object.keys(sortObject);

        // Return array if no sort object is supplied.
        if (!sortKeys.length) {
            return array;
        }

        // Change the values of the sortObject keys to -1, 0, or 1.
        for (let key in sortObject) {
            sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1 : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
        }

        const keySort = (a, b, direction) => {
            direction = direction !== null ? direction : 1;

            if (a === b) { // If the values are the same, do not switch positions.
                return 0;
            }

            // If b > a, multiply by -1 to get the reverse direction.
            return a > b ? direction : -1 * direction;
        };

        return array.sort((a, b) => {
            let sorted = 0;
            let index = 0;

            // Loop until sorted (-1 or 1) or until the sort keys have been processed.
            while (sorted === 0 && index < sortKeys.length) {
                const key = sortKeys[index];

                if (key) {
                    const direction = sortObject[key];

                    let varA = '';
                    let varB = '';

                    if (a.hasOwnProperty(key)) {
                        let days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN', 'WEEKDAY', 'WEEKEND'];

                        if ([8, 9, 10, 11, 12, 13, 14, 15, 16].indexOf(+key) !== -1) {
                            varA = withoutDollar(a[key]);
                            varB = withoutDollar(b[key]);
                        }
                        else if ([2, 3, 4].indexOf(+key) !== -1) {
                            varA = a[key] ? a[key].toUpperCase() : '';
                            varB = b[key] ? b[key].toUpperCase() : '';
                        }
                        else if ([6, 7].indexOf(+key) !== -1) {
                            varA = moment(a[key], "LT");
                            varB = moment(b[key], "LT");
                        }
                        else if (+key === 5) {
                            varA = a[key] ? a[key].toUpperCase() : 'MON';
                            varB = b[key] ? b[key].toUpperCase() : 'MON';
                            varA = days.indexOf(varA);
                            varB = days.indexOf(varB);
                        } else {
                            varA = a[key];
                            varB = b[key];
                        }
                    }

                    sorted = keySort(varA, varB, direction);
                    index++;
                }
            }

            return sorted;
        });
    };

    let withoutDollar = (string) => {
        let number = 0;
        if (typeof string === 'string') {
            number = string.split('$').join('').split(',').join('');
            number = isNaN(parseFloat(number)) ? 0 : parseFloat(number);
        } else if (typeof string === 'number') {
            number = string;
        }
        return number;
    };

    let withDollar = (number) => {
        number = number.toFixed(2);
        let integers = number.split('.')[0];
        let decimals = number.split('.')[1];
        let x = integers.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return '$' + x1 + x2 + '.' + decimals;
    };

    let withDecimals = (number, count) => {
        number = number.toFixed(count);
        let integers = number.split('.')[0];
        let decimals = number.split('.')[1];
        let x = integers.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2 + '.' + decimals;
    };

    let nameOrEmpty = (string) => {
        return string === null ? '' : string;
    };

    let displayVendorMatchingTable = () => {
        let table = $('<table border="1" class="vendor-matching"></table>');

        //Create table header
        let thead = $('<thead></thead>');
        let theadTr = $('<tr></tr>');
        for (let i = 0; i < vendorMatching.header.length; i++) {
            theadTr.append($('<th>' + vendorMatching.header[i] + '</th>'))
        }
        thead.append(theadTr);

        //Create table body
        let tbody = $('<tbody></tbody>');

        for (let station in vendorMatching.orders) {
            if (vendorMatching.orders.hasOwnProperty(station)) {
                let order = vendorMatching.orders[station];
                const apendMarketClient = order['market_client'] ? " (" + station.split("_")[1] + "/" + order['market_client'] + ")" : "";
                let tr = $('<tr data-station="' + station + '"></tr>');
                let stationTd = $('<td class="station">' + nameOrEmpty((station.split("_"))[0] + apendMarketClient) + '</td>');
                let vendorTd = $('<td class="vendor"></td>');

                // Select
                let vendorSelect = $('<select data-live-search="true"></select>');
                let defaultOption = $('<option value="none">Select the match</option>');
                let hasSelectedVendor = false;

                for (let v = 0; v < vendorMatching.vendors.length; v++) {
                    let vendor = vendorMatching.vendors[v];
                    const vendor_full_name = nameOrEmpty(vendor.name) +
                        ' - ' + nameOrEmpty(vendor.station) +
                        ' - ' + nameOrEmpty(vendor.network) +
                        ' - ' + nameOrEmpty(vendor.contact_name);
                    let option = $('<option value="' + vendor.vendor_id + '" data-vendor-markets-id="' + vendor.vendor_markets_id + '">' + nameOrEmpty(vendor_full_name) + '</option>');
                    if (vendor.vendor_markets_id === order['vendor_markets_id']) {
                        hasSelectedVendor = true;
                        option.attr('selected', 'selected');
                    }
                    if (order['market_short_name'] === vendor.market_id) {
                        vendorSelect.append(option);
                    }
                }

                if (!hasSelectedVendor) {
                    defaultOption.attr('selected', 'selected');
                }
                vendorSelect.prepend(defaultOption);
                vendorTd.append(vendorSelect);


                tr.append(stationTd);
                tr.append(vendorTd);
                tbody.append(tr);
            }
        }

        //Append header and body to table
        table.append(thead);
        table.append(tbody);

        $('#step-5-table').html(table);
        $("#step-5-table .vendor-matching select").selectpicker();
    };

    let getAdBuyingCalculatorState = (sheet, spreadsheet_id, market_id) => {
        if (sheet && spreadsheet_id && market_id) {
            $.ajax({
                type: 'POST',
                url: baseUrl + 'get-ad-buying-calculator-record',
                enctype: 'multipart/form-data',
                data: {
                    market_id: market_id,
                    spreadsheet_id: spreadsheet_id,
                    sheet: sheet,
                },
                success: function (data) {
                    if (data) {
                        $(".btn-resume").show();
                        $(".btn-supplemental").show();
                    } else {
                        $(".btn-resume").hide();
                        $(".btn-supplemental").hide();
                    }
                },
                error: function (err) {
                    console.log(err);
                    $(".btn-resume").hide();
                    $(".btn-supplemental").hide();
                }
            });
        }
    };

    let processAdBuyingCalculator = (btn_obj, action_type) => {
        let button = btn_obj;
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();
        //Range Picker for step two
        new Lightpick({
            field: document.getElementById('look-back-date-start'),
            secondField: document.getElementById('look-back-date-end'),
            singleDate: false,
            format: 'MM/DD/YYYY',
            onSelect: function (start, end) {
                look_back_date.start = start ? start.format('DD-MM-YYYY') : null;
                look_back_date.end = end ? end.format('DD-MM-YYYY') : null;
            }
        });
        let form = $('#step-1-form');
        let action = form.attr('action');
        let formData = new FormData(form[0]);
        // let buying_budget = form.find('#buying-budget').val();
        // formData.append('budget', buying_budget);

        formData.append('look_back_date[start]', look_back_date.start);
        formData.append('look_back_date[end]', look_back_date.end);
        formData.append('action_type', action_type);
        // formData.append('header', JSON.stringify(sheet.header));
        // formData.append('rows', JSON.stringify(sheet.rows));

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,

            success: function (data) {
                if (data.success) {
                    $('#step-1-errors').hide(200);
                    $('#step-3-errors').hide(200);
                    $('body > main > .container_large').addClass('max-width-100');
                    $('#step-3-tab').tab('show');

                    budget = data["budget"];
                    modalTotalBudget = data["budget"];
                    spend = data["spend"];
                    difference = data["difference"];
                    expected_leads_count = data["expected_leads_count"];
                    look_back_date = data["look_back_date"];
                    slotSelection.header = data["header"];
                    slotSelection.rows = JSON.parse(JSON.stringify(data["rows"]));
                    duplicateRow = JSON.parse(JSON.stringify(slotSelection.rows.slice()));//uz//it will maintain main section calculations
                    slotSelection.core = JSON.parse(JSON.stringify(data["rows"]));
                    slotSelection.sorts = {};
                    slotSelection.filters = data['filters'];
                    slotSelection.days_list = data['days_list'];
                    slotSelection.filtered = {
                        stations_networks: [],
                        zones: [],
                        programs: [],
                        days: [],
                        beginning_time: {
                            from: '12:00 AM',
                            to: '11:59 PM'
                        },
                        ending_time: {
                            from: '12:00 AM',
                            to: '11:59 PM'
                        }
                    };
                    makeGroup();
                    $('#step-3-selected-rows').css('display', 'flex');
                    //Range Picker for step three
                    new Lightpick({
                        field: document.getElementById('refresh-look-back-date-start'),
                        secondField: document.getElementById('refresh-look-back-date-end'),
                        singleDate: false,
                        format: 'MM/DD/YYYY',
                        startDate: moment(look_back_date.start, 'DD-MM-YYYY'),
                        endDate: moment(look_back_date.end, 'DD-MM-YYYY'),
                        onSelect: function (start, end) {
                            look_back_date.start = start ? start.format('DD-MM-YYYY') : null;
                            look_back_date.end = end ? end.format('DD-MM-YYYY') : null;
                        }
                    });
                    var spreadsheet_id = data["spreadsheet_id"];
                    var sheet_id = data["sheet_id"];
                    client = data["client"];
                    market = data["market"];
                    sheet.header = data["header"];
                    sheet.rows = data["rows"];
                    $('#buying-spreadsheet').val(spreadsheet_id);
                    $('#buying-sheet').val(sheet_id);

                    let messages = [];
                    if (client) {
                        messages.push(`<p>Selected Client is ${client["client_name"]} (${client["client_id"]})</p>`);
                    }
                    if (market) {
                        messages.push(`<p>Selected Market ID is ${market["market_id"]}</p>`);
                    }
                    if (messages.length > 0) {
                        $('#step-2-messages').html(messages.join('<br>')).fadeIn();
                    }
                    messages.push($('<p>Budget: <span class="selected-budget">' + withDollar(budget) + '</span></p>'));
                    messages.push($('<p>Spend: <span class="selected-spend">' + withDollar(spend) + '</span></p>'));
                    messages.push($('<p>Difference: <span class="selected-difference">' + withDollar(difference) + '</span></p>'));
                    messages.push($('<p>Expected leads: <span class="selected-expected-leads-count">' + withDecimals(expected_leads_count, 2) + '</span></p>'));
                    $('#step-3-messages').html(messages).fadeIn();

                    setSlotSelectionFilters();
                    displaySlotSelectionTable();

                } else {
                    $('#step-2-errors').html(data["errors"].join('<br>')).fadeIn();
                    $('#step-1-errors').html(data["errors"].join('<br>')).fadeIn();
                    if (data["error_code"] === "google_auth") {
                        $('#google_login_button').show();
                        $('#next-step-3').hide();
                    }
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    };

    const resetSlotConfirmationColumn = ({ addOrRemove }) => {
        slotConfirmation.rows.forEach((e, i) => {
            slotConfirmation.rows[i][18] = "";
        })
        if (addOrRemove) {
            resetBudgetSections(addOrRemove);
        }
        $("#buying-market-client-4").val("");
    }

    /**
     * this code is used in step 4
     * on select of market/client from dropdown it will open modal
     * and user will decide its total budget.
     */

    $(document).on('change', '#buying-market-client-4', function () {
        let option = $('#buying-market-client-4 option:selected');
        let marketClientName = option.data('market_name') + "_" + option.data('market_id') + "_" + option.data('client_id');
        $("#marketTags #hidden-buying-market-client-id").val(marketClientName);
        $("#marketTags #marketTagsLabel").html(option.data('client_name'));
        $("#marketTags #buying-market-client-totalBudget").val(0);
        $("#marketTags").modal("show");
    });

    const resetBudgetSections = (addOrRemove = false) => {
        $('.new-market-sections').each(function () {
            const e = $(this);
            e.find('.selected-spend').html(withDollar(0));
            e.find('.selected-difference').html(withDollar(addOrRemove ? e.find('.selected-budget').data("budget") : 0));
            e.removeClass("alert-danger");
        })
    }

    /**
     * on keyup total budget it will make sure sub-budget will not exeed total budget
     * on click save button, it will display market/client budget in step 4 screen
     * it also will manipulate table column by adding market/client in dropdown
     */

    $(document).on('click keyup',
        '#marketTags #modal-marketTags-save, #marketTags #buying-market-client-totalBudget, .new-market-sections-close-button'
        , function () {
            const e = $(this);
            let number = Number($("#marketTags #buying-market-client-totalBudget").val());
            const hiddenID = $("#marketTags #hidden-buying-market-client-id").val();
            const title = $("#marketTags #marketTagsLabel").html();
            $("#marketTags #modal-marketTags-save").prop("disabled", false)
            const remainingBudget = modalTotalBudget - number;
            if (e[0].tagName === "INPUT") {
                if (remainingBudget < 0) {
                    $("#marketTags #modal-marketTags-save").prop("disabled", true)
                } else {
                    $("#marketTags #modal-marketTags-save").prop("disabled", false)
                }
            } else if (e[0].tagName === "BUTTON" && number > 0 && !e.hasClass("new-market-sections-close-button")) {
                modalTotalBudget = remainingBudget;
                let messages = "";
                messages += '<div id="' + hiddenID + '" class="col-3 new-market-sections float-left alert alert-success">';
                messages += '<p>Budget: <span class="selected-budget" data-budget="' + number + '">' + withDollar(number) + '</span>&nbsp;&nbsp;<span data-title="' + title + '" data-hiddenID="' + hiddenID + '"> (' + title + ')</span><button type="button" class="close new-market-sections-close-button" aria-label="Close"><span aria-hidden="true">×</span></button></p>';
                messages += '<p>Spend: <span class="selected-spend">' + withDollar(0) + '</span></p>';
                messages += '<p>Difference: <span class="selected-difference">' + withDollar(number) + '</span></p>';
                messages += '<p>Expected leads: <span class="selected-expected-leads-count">' + withDecimals(0, 4) + '</span></p></div>';
                $('#step-4-messages').after(messages);
                $("#marketTags #marketTagsLabel").html("");
                $("#marketTags").modal("hide");
                /**reset spend and difference */
                resetBudgetSections();
                resetSlotConfirmationColumn({ addOrRemove: 0 });
                reRenderTableOnConfirmationSlot({ hiddenID, title, addOrRemove: 0 });
            } else if (e[0].tagName === "BUTTON" && e.hasClass("new-market-sections-close-button")) {
                number = e.prev().prev().data("budget");
                modalTotalBudget = modalTotalBudget + number;
                resetSlotConfirmationColumn({ addOrRemove: 1 });
                reRenderTableOnConfirmationSlot({ hiddenID: e.prev().data("hiddenid"), title: e.prev().data("title"), addOrRemove: 1 });
                e.parent().parent().remove();
            }
        });

    //Select market and client
    $(document).on('change', '#buying-market-client', function () {
        let option = $('#buying-market-client option:selected');

        $('#buying-market-id').val(option.data('market_id'));
        $('#buying-client-id').val(option.data('client_id'));

        if (option.data('sheet_id')) {
            $('#buying-spreadsheet').val(option.data('sheet_id'));
            getSpreedSheet(option.data('sheet_id'));
        }
    });

    //Select market and client
    $(document).on('change', '#buying-sheet', function () {
        let market_id = $('#buying-market-id').val();
        let spreadsheet_id = $('#buying-spreadsheet').val();
        let sheet = $('#buying-sheet').val();

        getAdBuyingCalculatorState(sheet, spreadsheet_id, market_id);
    });

    //Get Spreed sheet
    $(document).on('change', '#buying-spreadsheet', function (e) {
        getSpreedSheet($(this).val());
    });

    // supplemental ad buying calculator process
    $(document).on('click', '#supplemental', function () {
        processAdBuyingCalculator($(this), 'supplemental');
    });

    // resume ad buying calculator process
    $(document).on('click', '#resume', function () {
        processAdBuyingCalculator($(this), 'resume');
    });

    // start new ad buying calculator process
    $(document).on('click', '#start-new', function () {
        processAdBuyingCalculator($(this), 'new');
    });

    //Back to step 1
    $(document).on('click', '#back-step-1', function (e) {
        $('#step-1-tab').tab('show');
    });

    //Go to step 3
    $(document).on('click', '#next-step-3', function (e) {
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let form = $('#step-2-form');
        let action = form.attr('action');

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: {
                client_id: client.client_id,
                market_id: market.market_id,
                budget: form.find('#buying-budget').val(),
                look_back_date: look_back_date,
                header: JSON.stringify(sheet.header),
                rows: JSON.stringify(sheet.rows)
            },
            success: function (data) {
                if (data.success) {
                    $('body > main > .container_large').addClass('max-width-100');
                    $('#step-2-errors').hide(200);
                    $('#step-3-errors').hide(200);
                    $('#step-3-tab').tab('show');

                    budget = data["budget"];
                    modalTotalBudget = data["budget"];
                    spend = data["spend"];
                    difference = data["difference"];
                    expected_leads_count = data["expected_leads_count"];
                    look_back_date = data["look_back_date"];
                    slotSelection.header = data["header"];
                    slotSelection.rows = JSON.parse(JSON.stringify(data["rows"]));
                    duplicateRow = JSON.parse(JSON.stringify(slotSelection.rows.slice()));//uz//it will maintain main section calculations
                    slotSelection.core = JSON.parse(JSON.stringify(data["rows"]));
                    slotSelection.sorts = {};
                    slotSelection.filters = data['filters'];
                    slotSelection.days_list = data['days_list'];
                    slotSelection.filtered = {
                        stations_networks: [],
                        zones: [],
                        programs: [],
                        days: [],
                        beginning_time: {
                            from: '12:00 AM',
                            to: '11:59 PM'
                        },
                        ending_time: {
                            from: '12:00 AM',
                            to: '11:59 PM'
                        }
                    };

                    //Range Picker for step three
                    new Lightpick({
                        field: document.getElementById('refresh-look-back-date-start'),
                        secondField: document.getElementById('refresh-look-back-date-end'),
                        singleDate: false,
                        format: 'MM/DD/YYYY',
                        startDate: moment(look_back_date.start, 'DD-MM-YYYY'),
                        endDate: moment(look_back_date.end, 'DD-MM-YYYY'),
                        onSelect: function (start, end) {
                            look_back_date.start = start ? start.format('DD-MM-YYYY') : null;
                            look_back_date.end = end ? end.format('DD-MM-YYYY') : null;
                        }
                    });

                    let messages = [];
                    messages.push($('<p>Budget: <span class="selected-budget">' + withDollar(budget) + '</span></p>'));
                    messages.push($('<p>Spend: <span class="selected-spend">' + withDollar(spend) + '</span></p>'));
                    messages.push($('<p>Difference: <span class="selected-difference">' + withDollar(difference) + '</span></p>'));
                    messages.push($('<p>Expected leads: <span class="selected-expected-leads-count">' + withDecimals(expected_leads_count, 4) + '</span></p>'));
                    $('#step-3-messages').html(messages).fadeIn();

                    setSlotSelectionFilters();
                    displaySlotSelectionTable();
                } else {
                    $('#step-2-errors').html(data["errors"].join('<br>')).fadeIn();
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });

    //Refresh data
    $(document).on('click', '#refresh-data', function (e) {
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let form = $('#step-1-form');
        let action = form.attr('action');

        let checked_rows = [];
        slotSelection.rows.map((row) => {
            if (row[0]) {
                checked_rows.push(row);
            }
        });
        var market_id = $("#buying-market-client").find('option:selected').attr("data-market_id");
        var client_id = $("#buying-market-client").find('option:selected').attr("data-client_id");
        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: {
                action_type: 'resume',
                client_id: client_id,
                market_id: market_id,
                budget: form.find('#buying-budget').val(),
                look_back_date: look_back_date,
                checked_rows: JSON.stringify(checked_rows),
                header: JSON.stringify(sheet.header),
                rows: JSON.stringify(sheet.rows),
                spreadsheet_id: form.find('#buying-spreadsheet').val(),
                sheet_id: form.find('#buying-sheet').val()
            },
            success: function (data) {
                if (data.success) {
                    $('#step-3-errors').hide(200);

                    budget = data["budget"];
                    spend = data["spend"];
                    difference = data["difference"];
                    expected_leads_count = data["expected_leads_count"];
                    look_back_date = data["look_back_date"];
                    slotSelection.header = data["header"];
                    slotSelection.rows = JSON.parse(JSON.stringify(data["rows"]));
                    duplicateRow = JSON.parse(JSON.stringify(slotSelection.rows.slice()));//uz//it will maintain main section calculations
                    slotSelection.core = JSON.parse(JSON.stringify(data["rows"]));
                    slotSelection.sorts = {};
                    slotSelection.filters = data['filters'];
                    slotSelection.filtered = {
                        stations_networks: [],
                        zones: [],
                        programs: [],
                        days: [],
                        beginning_time: {
                            from: '12:00 AM',
                            to: '11:59 PM'
                        },
                        ending_time: {
                            from: '12:00 AM',
                            to: '11:59 PM'
                        }
                    };

                    let messages = [];
                    messages.push($('<p>Budget: <span class="selected-budget">' + withDollar(budget) + '</span></p>'));
                    messages.push($('<p>Spend: <span class="selected-spend">' + withDollar(spend) + '</span></p>'));
                    messages.push($('<p>Difference: <span class="selected-difference">' + withDollar(difference) + '</span></p>'));
                    messages.push($('<p>Expected leads: <span class="selected-expected-leads-count">' + withDecimals(expected_leads_count, 4) + '</span></p>'));
                    $('#step-3-messages').html(messages).fadeIn();

                    setSlotSelectionFilters();
                    displaySlotSelectionTable();
                } else {
                    let message = data["errors"] ? data["errors"].join('<br>') : data["error"];
                    $('#step-3-errors').html(message).fadeIn();
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function (error) {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
                $('#step-3-errors').html(error["responseJSON"]["message"]).fadeIn();
            }
        });
    });

    //Back to step 2
    $(document).on('click', '#back-step-2', function (e) {
        swal.fire({
            title: 'Are you sure you want to go back ?',
            text: 'This will start the ad buying process all over and delete your current ad buy session.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.value) {
                $('#step-1-tab').tab('show');
            }
            // if (result.value) {
            //     $('body > main > .container_large').removeClass('max-width-100');
            // }
        });
    });

    //Go to step 4
    $(document).on('click', '#next-step-4', function (e) {
        let button = $(this);

        let nextStepFour = () => {
            button.attr('disabled', true);
            button.find('.fa').hide();
            button.find('.fa-spinner').show();

            let action = button.data('action');

            $.ajax({
                type: 'POST',
                url: action,
                enctype: 'multipart/form-data',
                data: {
                    rows: JSON.stringify(slotSelection.core)
                },
                success: function (data) {
                    if (data.success) {
                        $('#step-3-errors').hide(200);
                        $('#step-4-errors').hide(200);
                        $('#step-4-tab').tab('show');
                        // slotConfirmation.header = slotSelection.header;//uz
                        slotConfirmation.header = data["header"];
                        slotConfirmation.rows = data["rows"];
                        slotConfirmation.sorts = {};

                        let messages = [];
                        arrayMarketClient = [];// this is used for adding new market/client in step-4
                        messages.push($('<p>Budget: <span class="selected-budget">' + withDollar(budget) + '</span></p>'));
                        messages.push($('<p>Spend: <span class="selected-spend">' + withDollar(spend) + '</span></p>'));
                        messages.push($('<p>Difference: <span class="selected-difference">' + withDollar(difference) + '</span></p>'));
                        messages.push($('<p>Expected leads: <span class="selected-expected-leads-count">' +
                            withDecimals(Object.keys(rowSelected).reduce((prev, key) => {
                                prev += rowSelected[key][16];
                                return prev;
                            }, 0), 2)
                            + '</span></p>'));
                        $('#step-4-messages').html(messages).fadeIn();

                        displaySlotConfirmationTable();
                    } else {
                        $('#step-3-errors').html(data["error"]).fadeIn();
                    }

                    button.attr('disabled', false);
                    button.find('.fa').show();
                    button.find('.fa-spinner').hide();
                },
                error: function () {
                    button.attr('disabled', false);
                    button.find('.fa').show();
                    button.find('.fa-spinner').hide();
                }
            });
        };

        if (difference < 0) {
            swal.fire({
                title: 'You are over budget by ' + withDollar(difference) + ' <br> Proceed?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.value) {
                    nextStepFour();
                }
            });
        } else {
            nextStepFour();
        }
    });

    //Back to step 3
    $(document).on('click', '#back-step-3', function (e) {
        $('.new-market-sections').remove();
        modalTotalBudget = budget;
        $('#step-3-tab').tab('show');
    });

    //Go to step 5
    $(document).on('click', '#next-step-5', function (e) {
        let button = $(this);
        const nextStepFive = () => {
            button.attr('disabled', true);
            button.find('.fa').hide();
            button.find('.fa-spinner').show();

            let action = button.data('action');

            $.ajax({
                type: 'POST',
                url: action,
                enctype: 'multipart/form-data',
                data: {
                    market_id: market.id,
                    rows: JSON.stringify(slotConfirmation.rows)
                },
                success: function (data) {
                    if (data.success) {
                        $('#step-4-errors').hide(200);
                        $('#step-5-tab').tab('show');

                        $('.vendor-fields #week_of').datepicker({
                            daysOfWeekDisabled: [0, 2, 3, 4, 5, 6],
                            multidate: true,
                            multidateSeparator: ', '
                        }).on("change", function () {
                            vendorMatching.fields.week_of = [];

                            $(this).val().split(', ').map((item) => {
                                if (item) {
                                    vendorMatching.fields.week_of.push(item);
                                }
                            });

                            if (vendorMatching.fields.week_of.length) {
                                $('.vendor-fields .number_of_weeks').html(' | # of weeks (' + vendorMatching.fields.week_of.length + ')');
                            } else {
                                $('.vendor-fields .number_of_weeks').html('');
                            }
                        });

                        $('.vendor-fields #separation').val(45);
                        $('.vendor-fields #market_name').val(market['market_name'] + ' (' + market['market_id'] + ')');
                        $('.vendor-fields #media').val('TV');

                        vendorMatching.orders = data.orders;
                        vendorMatching.vendors = data.vendors;
                        vendorMatching.fields = {
                            week_of: []
                        };

                        displayVendorMatchingTable();
                    } else {
                        $('#step-4-errors').html(data["error"]).fadeIn();
                    }

                    button.attr('disabled', false);
                    button.find('.fa').show();
                    button.find('.fa-spinner').hide();
                },
                error: function () {
                    button.attr('disabled', false);
                    button.find('.fa').show();
                    button.find('.fa-spinner').hide();
                }
            });
        }
        let showWarningdialogue = false;
        $('.new-market-sections').each(function () {
            const e = $(this);
            const d = withoutDollar(e.find('.selected-difference').html());
            if (d < 0) {
                showWarningdialogue = true;
                return;
            }
        });
        if (showWarningdialogue) {
            swal.fire({
                title: 'You are over budget! <br> Proceed?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.value) {
                    nextStepFive();
                }
            });
        } else {
            nextStepFive();
        }
    });

    //Back to step 4
    $(document).on('click', '#back-step-4', function (e) {
        $('#step-4-tab').tab('show');
    });
    //Back to step 5
    $(document).on('click', '#back-step-5', function (e) {
        $('#step-5-tab').tab('show');
        $('#step-6-errors').html("").fadeOut();
    });

    //Confirm
    $(document).on('click', '#confirm-buying', function (e) {
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();
        let action = button.data('action');

        let fields = {
            week_of: vendorMatching.fields.week_of,
            separation: $('.vendor-fields #separation').val(),
            market_name: $('.vendor-fields #market_name').val(),
            media: $('.vendor-fields #media').val()
        };

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: {
                sheet_id: sheet_id,
                client_id: client.client_id,
                market_id: market.id,
                fields: fields,
                orders: JSON.stringify(vendorMatching.orders),
                sheet: JSON.stringify(slotSelection.core)
            },
            success: function (data) {
                $('#step-6-tab').tab('show');

                if (data.success) {
                    $('#back-step-5').parent().parent().html("");
                    $('#step-6-messages').html($('<p>Orders created successfully.</p>')).fadeIn();

                    for (let order of data.orders) {
                        let example = $('#orders-table .order-example').clone();
                        example.find('td:nth-child(1)').html(order['id']);
                        example.find('td:nth-child(2)').html(order['created_at']);
                        example.find('td:nth-child(3)').html(order['client']['client_name']);
                        example.find('td:nth-child(4)').html(order['market']['market_id']);
                        example.find('td:nth-child(5)').html(order['station']);
                        example.find('td:nth-child(6)').html(order['media']);
                        example.find('td:nth-child(7)').html('W/O ' + order['info']['period'].join(' & '));
                        example.find('td:nth-child(8) a').attr('href', baseUrl + 'order/' + order['id']);
                        example.find('td:nth-child(8) form').attr('action', baseUrl + 'order/' + order['id'] + '/download');
                        example.removeClass('order-example');
                        $('#orders-table tbody').append(example);
                    }

                    $('main > .container').removeClass('max-width-100');
                    $('#confirm-success-area').removeClass('d-none');
                } else {
                    $('#step-6-errors').html(data["error"]).fadeIn();
                    $('#confirm-error-area').removeClass('d-none');
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });

    $(document).ready(() => {
        $("#showSplitMarketClient").hide();
        $("#fillMarketClient").hide();
    })
    let toggleSplit = false;
    $(document).on('change', '#toggleSplit', function () {
        const $this = $(this);
        if (toggleSplit) {
            toggleSplit = false;
            $("#showSplitMarketClient").hide(1000);
            $("#fillMarketClient").hide(1000);
            arrayMarketClient = [];
            displaySlotConfirmationTable();
            $(".new-market-sections").remove();
            modalTotalBudget = budget;
            $("#buying-market-client-4").val("");
            slotConfirmation.rows.forEach((e, index) => {
                slotConfirmation.rows[index][18] = "";
            });
        } else {
            toggleSplit = true;
            $("#showSplitMarketClient").show(1000);
            $("#fillMarketClient").show(1000);
        }
    });
    $(document).on('click', '#fillMarketClient', function () {
        if (arrayMarketClient && arrayMarketClient.length > 0) {
            resetBudgetSections();
            let i = 0;
            slotConfirmation.rows.forEach((e, index) => {
                slotConfirmation.rows[index][18] = "";
                updateSelectedMarketClientTopSection(null, null, 18, index, arrayMarketClient[i].id);
                slotConfirmation.rows[index][18] = arrayMarketClient[i].id;
                i++;
                if (i === arrayMarketClient.length) {
                    i = 0;
                }
            })
            setImmediate(() => displaySlotConfirmationTable(arrayMarketClient))
        }
    });
});
